<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
        <el-form-item label="所属项目">
         <el-select  clearable v-model="value" @change="SubordinateChange(value)" placeholder="请选择所属项目">
                    <el-option
                    v-for="item in ClassifyNameList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="点位名称">
        <el-input v-model="formLabelAlign.spotName" size="small"></el-input>
    </el-form-item>
    <el-form-item label="点位编码">
        <el-input v-model="formLabelAlign.spotCode" size="small"></el-input>
    </el-form-item>
        <el-form-item label="所属系统">
        <el-input v-model="formLabelAlign.insSystem" size="small"></el-input>
    </el-form-item>
    <el-form-item label="地址">
        <el-input v-model="formLabelAlign.location" size="small"></el-input>
    </el-form-item>
        <el-form-item label="巡检人员">
        <el-input v-model="formLabelAlign.staff" size="small"></el-input>
    </el-form-item>
    <el-form-item label="巡查岗位">
        <el-input v-model="formLabelAlign.source" size="small"></el-input>
    </el-form-item>
        <el-form-item label="异常工单号">
        <el-input v-model="formLabelAlign.exOrder" size="small"></el-input>
    </el-form-item>
    <el-form-item label="异常维修人员">
        <el-input v-model="formLabelAlign.ramark" size="small"></el-input>
    </el-form-item>
        <el-form-item label="异常图片">
          <!-- <img :src="formLabelAlign.exImgUrls" alt="" srcset="" style="width:100%;height:100%"> -->
        <el-image 
    style="width: 100px; height: 100px"
    :src="url" 
    size="small"
    :preview-src-list="srcList">
  </el-image>
    </el-form-item>
        <el-form-item label="异常项">
      <el-input type="textarea" autosize  v-model="formLabelAlign.exDetail"></el-input>
    </el-form-item>
        <el-form-item label="补充说明">
      <el-input type="textarea" autosize  v-model="formLabelAlign.field"></el-input>
    </el-form-item>

</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "PollingRecordDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},
        ClassifyNameList:[],
        value:"",
        ForwardText:"",
        srcList:[],
        url:"",
        SubordinateList:[],
    };
  },
  methods: {

    modification(){
        
    },
    SubordinateChange(){

    },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>